import graphql__1a5e8e6d699b9f71281a from "./__generated__/DownVoteButton_votable.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";
import { defineMessages } from "react-intl";

import VoteButton from "./VoteButton";
import { useVoteButtonsLabel } from "./useVoteButtonsLabel";

const VOTE_TYPE_DOWN = "DOWN";

const DownVoteButton = props => {
  const votable = useFragment(DownVoteButton_votable, props.votable);
  const { votes, votesMode, currentViewerVote, authorizations } = votable;

  const isActive = currentViewerVote === VOTE_TYPE_DOWN;

  const { label, votesCountScreenReaderLabel } = useVoteButtonsLabel({
    votable,
    intlMessages,
    voteType: VOTE_TYPE_DOWN
  });

  const buttonClassName = classNames("text-danger", props.buttonClassName, {
    "down-vote-button--active": isActive,
    "bg-white": !isActive
  });

  const iconClassName = classNames({
    "icon-dislike": votesMode === "LIKES",
    "fa fa-caret-down margin-right-none": votesMode === "VOTES"
  });

  return (
    <VoteButton
      {...props}
      votable={votable}
      tooltipContent={label}
      screenReaderLabel={label}
      voteType={VOTE_TYPE_DOWN}
      className="down-vote-button-container"
      iconClassName={iconClassName}
      buttonClassName={buttonClassName}
      votesCount={votes.down}
      votesCountScreenReaderLabel={votesCountScreenReaderLabel}
      authorization={authorizations.submitVote}
      triggerOnSignIn={true}
    />
  );
};

const DownVoteButton_votable = graphql__1a5e8e6d699b9f71281a;

export default DownVoteButton;

const intlMessages = defineMessages({
  label: {
    id: "downVoteButton.vote.label",
    defaultMessage: "Je vote contre {remainingVotesMessage}"
  },
  likeLabel: {
    id: "downVoteButton.like.label",
    defaultMessage: "Je n'aime pas {remainingVotesMessage}"
  },
  labelActive: {
    id: "downVoteButton.vote.labelActive",
    defaultMessage: "Retirer mon vote contre"
  },
  likeLabelActive: {
    id: "downVoteButton.like.labelActive",
    defaultMessage: "Retirer mon dislike"
  },
  labelAdd: {
    id: "downVoteButton.vote.labelAdd",
    defaultMessage: "Ajouter un vote contre {remainingVotesMessage}"
  },
  likeLabelAdd: {
    id: "downVoteButton.like.labelAdd",
    defaultMessage: "Ajouter un dislike {remainingVotesMessage}"
  },
  labelVotesCountScreenReaderLabel: {
    id: "downVoteButton.vote.votesCountScreenReaderLabel",
    defaultMessage: "(votes contre)"
  },
  likeLabelVotesCountScreenReaderLabel: {
    id: "downVoteButton.like.votesCountScreenReaderLabel",
    defaultMessage: "(dislikes)"
  }
});
